import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { useProjectMapping } from "../../../data/projects/useAllProjects";
import { useProjectsForMainService } from "../../../data/services/useProjectsForMainService";
import { useSubServiceForMainServiceMap } from "../../../hooks/serviceMappings/useSubServiceForMainServiceMap";
import { NWONSectionTitle } from "../../01-atoms/NWONSectionTitle/NWONSectionTitle";
import NWONCTASection from "../../03-organisms/NWONCTASection/NWONCTASection";
import NWONHeroSection from "../../03-organisms/NWONHeroSection/NWONHeroSection";
import NWONProjectsSection from "../../03-organisms/NWONProjectsSection/NWONProjectsSection";
import NWONSection from "../../03-organisms/NWONSection/NWONSection";
import NWONServicesSection from "../../03-organisms/NWONServicesSection/NWONServicesSection";
import NWONSubServiceCardGrid from "../../03-organisms/NWONSubServiceCardGrid/NWONSubServiceCardGrid";
import { NWONServicePageProps } from "./NWONServicePageInterfaces";

const NWONServicePage = (props: NWONServicePageProps): JSX.Element => {
  const { service } = props;
  const { t } = useTranslation<"pages">("pages");
  const projectMap = useProjectMapping();
  const projectsForMainService = useProjectsForMainService();
  const subServiceForMainServiceMap = useSubServiceForMainServiceMap();

  const projectData = useMemo(
    () =>
      projectsForMainService[service.service].map(
        (project) => projectMap[project]
      ),
    [projectMap, projectsForMainService, service.service]
  );

  return (
    <>
      <NWONHeroSection
        title={service.title}
        subtitle={service.text}
        slideInformation={service.heroSlides}
        logos={service.heroLogos}
      />

      <NWONSectionTitle title={service.subServiceHeader} />

      <NWONSection>
        <NWONSubServiceCardGrid
          subServices={subServiceForMainServiceMap[service.service]}
        />
      </NWONSection>

      <NWONCTASection
        teamMember={service.contactTeamMember}
        title={service.contactPersonHeader}
        subTitle={service.contactPersonSubTitle}
      />

      <NWONProjectsSection
        title={service.relatedProjectsHeader}
        projects={projectData}
        allProjectsButton={false}
      />

      <NWONServicesSection title={t("service.otherServicesHeader")} />
    </>
  );
};

export default NWONServicePage;
